import React, { useMemo } from 'react';
import { KeyMetricChartData } from 'src/components/organisms/KeyMetricChart';
import { getAggregateLevelData } from 'src/features/MM/utils/getAggregateLevelData';
import { AggregateLevel } from 'src/types';
import { useMMDataContext } from '../../../contexts/MMDataContext';
import { KeyMetricItem } from 'src/features/MM/components/molecules/KeyMetricItem';
import { Icon } from 'src/components/atoms/Icon';
import { calculateTrendFromTimeSeries } from 'src/features/MM/utils/calculateTrendFromTimeSeries';

type RoiProps = {
  aggregateLevel: AggregateLevel;
};

export const Roi: React.FC<RoiProps> = ({ aggregateLevel }) => {
  const { roi } = useMMDataContext();

  const keyMetricData: KeyMetricChartData = useMemo(() => {
    return {
      isLoading: roi.isLoading,
      isError: roi.isError,
      name: 'ROI',
      isEuro: false,
      summaryValue: roi.total,
      data: getAggregateLevelData(roi, aggregateLevel),
    };
  }, [roi, aggregateLevel]);

  const { upOrDown, upOrDownValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData]);

  return (
    <KeyMetricItem
      title="ROI"
      upOrDown={upOrDown}
      upOrDownValue={upOrDownValue}
      value={keyMetricData.summaryValue}
      icon={<Icon iconName="growth" />}
    />
  );
};
